import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/app/layouts/default.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/workspace/app/layouts/simple.vue").then(m => m.default || m))
}